import * as ko from "knockout";
import {VariableAbstract} from "./VariableAbstract";
import {IExportTemplate, TRouteId} from "../../index";
import {TServiceName} from "../../constants/ApiServices";
import {getRouteLabel} from "../../constants/RouteDefinitions";

export {template} from "./VariableAbstract";

export class viewModel extends VariableAbstract<IExportTemplate> {
    protected routeId: TRouteId = 'synctemplatedetails'
    protected serviceName: TServiceName = 'getexporttemplate'

    protected override getTitle(): string {
        const item = ko.unwrap(this.item)
        let ret = `((${getRouteLabel(this.routeId)}|uc))

((id)):
${item.id}

((name)):
${item.name}

((active)):
`
        if (item.active) {
            ret += `((yes))`
        } else {
            ret += `((no))`
        }

        const description = item.description;
        if (description) {
            ret += `

((description)):
${description}`
        }

        const syncstepName = item.syncstep?.syncstep.name;
        if (syncstepName) {
            ret += `

((synchronization step)):
${syncstepName}`
        }

        const rulesetName = item.ruleset?.name;
        if (rulesetName) {
            ret += `

((ruleset)):
${rulesetName}`
        }

        return ret
    }
}